import { makeAutoObservable } from "mobx"

export default class ReportInfluencerPerformance {

  constructor(reportInfluencerPerformance={}) {
    this.id = reportInfluencerPerformance.id
    this.campaign_report_id = reportInfluencerPerformance.campaign_report_id
    this.influencer_id = reportInfluencerPerformance.influencer_id
    this.performance = reportInfluencerPerformance.performance
    this.created_at = reportInfluencerPerformance.created_at
    this.updated_at = reportInfluencerPerformance.updated_at
    this.free_text = reportInfluencerPerformance.free_text
    this._destroy = false
    makeAutoObservable(this)
  }
}